import * as React from "react";

export type ComponentLayoutInfo = {
  width: number;
  height: number;
  top: number;
  left: number;
};

function getInfos(el?: any): ComponentLayoutInfo {
  if (!el) {
    return {
      width: 0,
      height: 0,
      top: 0,
      left: 0,
    };
  }
  return {
    width: el.offsetWidth,
    height: el.offsetHeight,
    top: el.offsetTop,
    left: el.offsetLeft,
  };
}

export function useComponentLayoutInfos<T = HTMLElement>(
  ref: React.RefObject<T>
) {
  const [componentLayoutInfos, setComponentLayoutInfos] = React.useState(
    getInfos(ref ? ref.current : undefined)
  );

  const handleResize = React.useCallback(() => {
    if (ref.current) {
      setComponentLayoutInfos(getInfos(ref.current));
    }
  }, [ref]);

  React.useLayoutEffect(() => {
    if (!ref.current) {
      return;
    }

    handleResize();
    const currentRef = ref.current;

    if (typeof (window as any).ResizeObserver === "function") {
      var resizeObserver = new (window as any).ResizeObserver(function () {
        handleResize();
      });
      resizeObserver.observe(currentRef);

      return function () {
        resizeObserver.disconnect(currentRef);
        resizeObserver = null;
      };
    } else {
      window.addEventListener("resize", handleResize);

      return function () {
        window.removeEventListener("resize", handleResize);
      };
    }
  });

  return componentLayoutInfos;
}
